import styled, { css } from 'styled-components';
import {
  CheckmarkCircleRegular,
  MoreCircleRegular,
  DismissCircleRegular,
  ChatBubblesQuestionRegular,
  WarningRegular,
  ClipboardRegular,
  PauseCircleRegular,
  PersonClockRegular,
  ErrorCircleRegular,
  ArrowSyncCircleRegular,
} from '@fluentui/react-icons';

const iconCommonStyles = css`
  width: 20px;
  height: 20px;
`;

export const ChatBubblesQuestionRegularIcon = styled(
  ChatBubblesQuestionRegular
)``;

export const WarningRegularIcon = styled(WarningRegular)``;

export const ClipboardRegularIcon = styled(ClipboardRegular)``;

export const ApprovedIcon = styled(CheckmarkCircleRegular)`
  ${iconCommonStyles};
  color: ${(props) => props.theme.successMessageColor};
`;

export const RejectedIcon = styled(DismissCircleRegular)`
  ${iconCommonStyles};
  color: ${(props) => props.theme.popupErrorColor};
`;

export const WaitingIcon = styled(MoreCircleRegular)`
  ${iconCommonStyles};
  color: ${(props) => props.theme.moreCircleIconColor};
`;

export const ResolvedIcon = styled(CheckmarkCircleRegular)`
  ${iconCommonStyles};
`;

export const WaitingFor3rdPartyIcon = styled(PersonClockRegular)`
  ${iconCommonStyles};
`;

export const InvalidIcon = styled(ErrorCircleRegular)`
  ${iconCommonStyles};
`;

export const OnHoldIcon = styled(PauseCircleRegular)`
  ${iconCommonStyles};
`;

export const CancelledIcon = styled(DismissCircleRegular)`
  ${iconCommonStyles};
`;

export const OpenIcon = styled(MoreCircleRegular)`
  ${iconCommonStyles};
`;

export const InProgressIcon = styled(ArrowSyncCircleRegular)`
  ${iconCommonStyles};
`;

export const StatusText = styled.span`
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`;
